import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PriceService from '../../Helpers/PriceService';
import API from '../../Helpers/API';
import { loadQuote } from '../../Actions/quote';
import RouteParser from '../../Helpers/RouteParser';
import { screenResize } from '../../Actions/actions';

const QuoteLoader = () => {
  const { formPage } = useParams();
  const [apiError, setApiError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [quoteInvalid, setQuoteInvalid] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const eventTypeUrl = new RouteParser().linkToEventTypePage();

  useEffect(() => {
    const validateQuote = async () => {
      const priceService = new PriceService(new API());

      try {
        const response = await priceService.getSavedQuote(formPage);
        const eventType = response.data.data.formData.eventType;
        const coverageUrl = new RouteParser(
          `/${eventType}/application`,
        ).linkToApplicationPage();
        dispatch(loadQuote(response.data.data.state));
        history.push(coverageUrl);
        dispatch(screenResize(window.innerWidth));
      } catch (e) {
        if (e.response.status === 422 || e.response.status === 404) {
          setQuoteInvalid(true);
        } else {
          setApiError(true);
        }
        setLoading(false);
      }
    };
    validateQuote();
  }, [formPage, dispatch, history]);

  return (
    <div className="quote-loader d-flex align-items-center justify-content-center mh--hf container">
      <div className="d-flex align-items-center">
        {loading ? (
          <>
            <Spinner animation="border" role="status" />
            <span className="ml-3">Loading your quote...</span>
          </>
        ) : (
          <>
            {apiError && (
              <Alert variant="error" className="mt-3">
                <i className="far fa-exclamation-circle alert__icon" />
                <div className="alert__text">
                  Sorry, we were unable to process your request. Please try
                  again or contact us at{' '}
                  <span className="text-nowrap">(844) 747-6240</span> or
                  gatherguard@intactinsurance.com for further assistance.{' '}
                </div>
              </Alert>
            )}
            {quoteInvalid && (
              <Alert variant="error" className="mt-3">
                <i className="far fa-exclamation-circle alert__icon" />
                <div className="alert__text">
                  Sorry, your link for the quote has expired or is no longer
                  valid. Please apply again{' '}
                  <Link to={eventTypeUrl}>
                    <u>here</u>
                  </Link>
                  . Or contact us at{' '}
                  <span className="text-nowrap">(844) 747-6240</span> or
                  gatherguard@intactinsurance.com for further assistance.{' '}
                </div>
              </Alert>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default QuoteLoader;
